











































































import { defineComponent, useRouter } from "@nuxtjs/composition-api";
import { SfNotification } from "@storefront-ui/vue";
import { useUiNotification, useUiState } from "~/composables";
import SvgImage from "~/components/General/SvgImage.vue";

export default defineComponent({
  name: "NotificationBar",
  components: {
    SfNotification,
    SvgImage,
  },
  setup() {
    const router = useRouter();
    const { notifications } = useUiNotification();
    const { toggleCartSidebar, isCartSidebarOpen } = useUiState();

    const handleCartView = (notification) => {
      if (!isCartSidebarOpen.value) {
        toggleCartSidebar();
      }
      notification.dismiss();
    };

    const gotoPath = (notification) => {
      router.push(notification.urlPath || "#");
      notification.dismiss();
    };

    return {
      notifications,
      toggleCartSidebar,
      isCartSidebarOpen,
      handleCartView,
      gotoPath,
    };
  },
});
